export default __webpack_public_path__ + "static/media/home-karin.9c3c6bd4.jpg";